import { gql } from '@apollo/client';

export const AI_QUERY = gql`
  query AIQuery($query: String!, $conversationId: String) {
    aiQuery(query: $query, conversationId: $conversationId) {
      ... on AIQueryResponse {
        message
        type
        data
        suggestedActions {
          label
          action
        }
      }
      ... on AIError {
        errorCode
        message
      }
    }
  }
`;
